import { Box } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavbarItem.css'; // Assuming you have some styles for the nav link
import { SvgIconComponent } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/types';

export default function NavBarItem({ name, href , Icon , closed }: { name: string; href: string ;Icon: SvgIconComponent , closed: boolean }) {

  const user = useSelector((state: RootState) => state.auth.user);

  if(name === "Admin" && user?.role !== "admin"){
    return null;  
  }


    return (
        <NavLink
        to={href}
        className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
        >
          <Box className = {`nav-item ${closed ? "closed" : ""}`} sx={{ color: "text.primary" }}>
            <Icon className={`nav-icon ${closed ? "closed" : ""}`} sx={{ color: "text.primary" }} /> 
            <span className={`nav-item-title ${closed ? "closed" : ""}`}>{name}</span>
          </Box>
      </NavLink>
    );
}